<template>
	<div>
        <div v-if="loading">
            <spinner-component :loading="loading"/>
        </div>

        <div v-if="error" class="error">
			{{ error }}
        </div>

		<div v-if="transaction">
			<div class="d-flex align-items-center justify-content-between mg-b-25">
                <h3 class="df-title">{{ `Transaction - ${this.transaction.uuid}` }}</h3>
				<div class="d-flex">
					<router-link class="btn btn-sm pd-x-15 btn-white shadow-sm mg-l-5" :to="{ name: 'transactions.manage' }">Go Back</router-link>
				</div>
            </div>
			<div class="row">
				<div class="col-md-12">
					<nav class="nav nav-line tx-medium" id="clientNav">
						<a href="#transaction-information" class="nav-link active" data-toggle="tab">Transaction Information</a>
						<a v-if="hasRequest" href="#request-information" class="nav-link" data-toggle="tab">Request</a>
					</nav>
				</div>

				<div class="tab-content wd-100p p-3">
					<transaction-information :transaction="transaction"/>

					<request-information v-if="hasRequest" :request="transaction.request"/>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		mounted() {},
		data() {
			return {
				refresh: false,
				loading: false,
				transaction: null,
				hasRequest: false,
				error: null
			};
		},
		created() {
			this.fetchTransaction();
		},
		computed: {},
		watch: {
			$route: "fetchTransaction",
			refresh: function(status) {
				if (status) {
					this.fetchTransaction();
				}
			}
		},
		methods: {
			fetchTransaction() {
				this.error = this.transaction = null;
				this.loading = true;

				axios
					.get(`/api/transactions/${this.$route.params.id}`)
					.then(response => {
						const transaction = response.data.data.transaction;

						if (!_.isEmpty(transaction)) {
							this.transaction = transaction;

							this.hasRequest = transaction.request[0] !== null;
						}
					})
					.catch(error => {
						this.error = error.toString();
					})
					.finally(() => {
						this.loading = this.refresh = false;
					});
			}
		}
	};
</script>